import { AxiosReportLas, AxiosGlobalFilters } from '../config';
import qs from 'qs';

const ActivitiesServices = {
  validateLogin: (login, token) => {
    return AxiosReportLas({
      method: 'post',
      url: `/v1/Relatorios/ValidarEmailUsuario?login=${login}`,
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  },
  getActivitiesPlans: ({ companyId, unitId, systemIds }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/planosatividades/ativos`,
      params: {
        empresaId: companyId,
        sistemasIds: systemIds,
        unidadeId: unitId,
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  },
  sendExcelByEmail: ({ login, site, empresa, dataInicial, dataFinal, sistemas, planoAtividades, status, token }) => {
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Relatorios/RelatorioAtividade',
      data: {
        login,
        site,
        empresa,
        dataInicial,
        dataFinal,
        sistemas,
        planoAtividades,
        status,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
        EmpresaId: empresa,
      },
    });
  },
  sendPDFByEmail: ({
    login,
    unidadeManutencao,
    empresa,
    dataPrevistaInicial,
    dataPrevistaFinal,
    dataRealizadaInicial,
    dataRealizadaFinal,
    sistemas,
    custos,
    materiaisUtilizados,
    assinaturas,
    medicoes,
    justificativaAtividadesNaoRealizadas,
    fotos,
    planoAtividades,
    status,
    token,
    fornecedores,
    executores,
    gruposAreas,
    subGrupoAreas,
    areas,
    tipoEquipamentos,
    equipmentos,
  }) => {
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Relatorios/RelatorioAtividadepdf',
      data: {
        login,
        email: login,
        unidadeManutencao,
        empresa,
        dataPrevistaInicial,
        dataPrevistaFinal,
        dataRealizadaInicial,
        dataRealizadaFinal,
        sistemas,
        custos,
        materiaisUtilizados,
        assinaturas,
        medicoes,
        justificativaAtividadesNaoRealizadas,
        fotos,
        planoAtividades,
        status,
        fornecedores,
        executores,
        gruposAreas,
        subGrupoAreas,
        areas,
        tipoEquipamentos,
        equipmentos,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
        EmpresaId: empresa,
      },
    });
  },
  sendPDFSummaryByEmail: ({
    login,
    unidadeManutencao,
    empresa,
    dataPrevistaInicial,
    dataPrevistaFinal,
    dataRealizadaInicial,
    dataRealizadaFinal,
    sistemas,
    custos,
    materiaisUtilizados,
    assinaturas,
    medicoes,
    justificativaAtividadesNaoRealizadas,
    fotos,
    planoAtividades,
    status,
    token,
    fornecedores,
    executores,
    gruposAreas,
    subGrupoAreas,
    areas,
    tipoEquipamentos,
    equipmentos,
  }) => {
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Relatorios/RelatorioAtividadeResumido',
      data: {
        login,
        email: login,
        unidadeManutencao,
        empresa,
        dataPrevistaInicial,
        dataPrevistaFinal,
        dataRealizadaInicial,
        dataRealizadaFinal,
        sistemas,
        custos,
        materiaisUtilizados,
        assinaturas,
        medicoes,
        justificativaAtividadesNaoRealizadas,
        fotos,
        planoAtividades,
        status,
        fornecedores,
        executores,
        gruposAreas,
        subGrupoAreas,
        areas,
        tipoEquipamentos,
        equipmentos,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
        EmpresaId: empresa,
      },
    });
  },
};

export { ActivitiesServices };
